import React from "react";
import styles from "./UsersDetailsPluginsTab.module.css";
import Card from "shared/Card";
import GroupPluginList from "./GroupPluginList";
import LOSPluginList from "./LOSPluginList";

const groupPluginList = [
  {
    id: "123",
    dsId: "100012207548166",
    userId: "100023307548156",
    groupId: "391792601626492",
    asAdmin: true,
    status: 1,
    date: "02/24/2020",
    time: "11:01:01",
    details: "",
  },
  {
    id: "456",
    dsId: "100012207548166",
    userId: "100023307548156",
    groupId: "391792601626492",
    asAdmin: false,
    status: 1,
    date: "02/24/2020",
    time: "11:01:01",
    details: "",
  },
  {
    id: "678",
    dsId: "100012207548166",
    userId: "100023307548156",
    groupId: "391792601626492",
    asAdmin: false,
    status: 1,
    date: "02/24/2020",
    time: "11:01:01",
    details: "",
  },
  {
    id: "123",
    dsId: "100012207548166",
    userId: "100023307548156",
    groupId: "391792601626492",
    asAdmin: true,
    status: 1,
    date: "02/24/2020",
    time: "11:01:01",
    details: "",
  },
  {
    id: "456",
    dsId: "100012207548166",
    userId: "100023307548156",
    groupId: "391792601626492",
    asAdmin: false,
    status: 1,
    date: "02/24/2020",
    time: "11:01:01",
    details: "",
  },
];

const losPluginList = [
  {
    id: "2",
    pluggedInIbo: "353894",
    pluggedInto: "2636550",
    pluginPin: "4",
    replace: true,
    status: 1,
  },
  {
    id: "6",
    pluggedInIbo: "353894",
    pluggedInto: "2636550",
    pluginPin: "4",
    replace: false,
    status: 1,
  },
  {
    id: "9",
    pluggedInIbo: "353894",
    pluggedInto: "2636550",
    pluginPin: "4",
    replace: true,
    status: 1,
  },
];

/**
 * Content in all details group plugins page.
 */

export function UsersDetailsPluginsTab() {
  return (
    <>
      <div className={styles.container}>
        <Card className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h5 className={styles.title}>GROUP PLUGINS</h5>
            <div className={styles.hr} />
          </div>

          <div className={styles.usersDiv}>
            <GroupPluginList plugins={groupPluginList} />
          </div>
        </Card>

        <Card className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h5 className={styles.title}>LOS PLUGINS</h5>
            <div className={styles.hr} />
          </div>

          <div className={styles.usersDiv}>
            <LOSPluginList plugins={losPluginList} />
          </div>
        </Card>
      </div>
    </>
  );
}
